/**
 * 프로모션 상품 유닛 스크립트 v4
 * 매크로에서 분리된 JavaScript 함수
 */
(function (window) {
  'use strict';

  // 초기화 여부를 추적하는 객체
  var initializedEvents = {};

  /**
   * HTML 이스케이프 함수 (XSS 방지)
   * @param {string} str - 이스케이프할 문자열
   * @returns {string} 이스케이프된 문자열
   */
  function escapeHtml(str) {
    if (!str) return '';
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return String(str).replace(/[&<>"']/g, function (m) {
      return map[m];
    });
  }

  /**
   * 프로모션 상품 유닛 초기화 함수
   * @param {Object} options - 설정 옵션
   * @param {string} options.nevntId - 이벤트 ID (필수)
   * @param {boolean} [options.useSlide=false] - 슬라이드 사용 여부
   * @param {boolean} [options.useTab=false] - 탭 사용 여부
   * @param {boolean} [options.useLayer=false] - 레이어 팝업 사용 여부
   * @param {string} [options.siteNm] - 사이트명
   * @param {string} [options.customSelector] - 커스텀 셀렉터
   * @param {string} [options.brandNm] - 브랜드명
   * @param {boolean} [options.comingsoonYn=false] - 곧 출시 예정 여부
   * @param {boolean} [options.uItemSamePrcYn=false] - 동일 가격 여부
   * @param {string} [options.soldoutText="인기상품!<br>매진되었습니다"] - 품절 텍스트
   * @param {boolean} [options.dealCheck=false] - 딜 체크 여부
   */
  window.initPromoUnitScriptV4 = function (options) {
    if (!options || !options.nevntId) {
      console.error('initPromoUnitScriptV4: nevntId is required');
      return;
    }

    // 이미 초기화된 이벤트인지 확인
    var eventKey = options.nevntId + '_' + (options.customSelector || 'default');
    if (initializedEvents[eventKey]) {
      console.warn('initPromoUnitScriptV4: Already initialized for nevntId ' + options.nevntId);
      return;
    }

    // 초기화 플래그 설정
    initializedEvents[eventKey] = true;

    var config = {
      nevntId: options.nevntId,
      useSlide: options.useSlide || false,
      useTab: options.useTab || false,
      useLayer: options.useLayer || false,
      siteNm: options.siteNm || false,
      customSelector: options.customSelector || false,
      brandNm: options.brandNm || false,
      comingSoon: options.comingsoonYn || false,
      ultemPrc: options.uItemSamePrcYn || false,
      soldoutText: options.soldoutText || '인기상품!<br>매진되었습니다',
      dealCheck: options.dealCheck || false
    };

    var oEventItemInfoSet = (function (s) {
      var welEventWrap = $('.evt_wrap_html'),
        welList = welEventWrap.find(
          (config.customSelector ? config.customSelector + ' ' : '') + '.cmbn_lst'
        ),
        welItems = welList.find('.cmbn_link[data-item-id]'),
        welSiteNos = welList.find('.cmbn_link[data-site-no]'),
        nRequestItem = welItems.length,
        nResponseItem = 0,
        sDocumentTitle = document.title,
        isInitialized = false,
        isInitializing = false;

      var oProductModel = {
        getItemId: function () {
          var itemIds = welItems
            .map(function () {
              return $(this).data('itemId');
            })
            .get()
            .filter(function (element, index, self) {
              return self.indexOf(element) === index;
            })
            .join(',');
          return itemIds;
        },
        getEventDomain: function () {
          var protocol = window.location.protocol.indexOf('https:') > -1 ? 'https://' : 'http://';
          var eventHostName = 'event.ssg.com';
          if (window.location.hostname.indexOf('local-') > -1) {
            eventHostName = 'dev-event.ssg.com';
          } else if (window.location.hostname.indexOf('dev-') > -1) {
            eventHostName = 'dev-event.ssg.com';
          } else if (
            window.location.hostname.indexOf('qa-') > -1 ||
            window.location.hostname.indexOf('qa2-') > -1
          ) {
            eventHostName = 'qa-event.ssg.com';
          } else if (window.location.hostname.indexOf('stg-') > -1) {
            eventHostName = 'stg-event.ssg.com';
          }

          return protocol + eventHostName;
        },
        getItemData: function (nevntId) {
          var defer = $.Deferred();
          var sId = '_' + Math.round(10000 * Math.random());
          var callbackName = 'jsonp_callback_' + sId;
          var searchParams = new URLSearchParams(location.search);
          var domainSiteNo =
            searchParams.get('domainSiteNo') != null ? searchParams.get('domainSiteNo') : '6005';
          // URL 파라미터 인코딩 (XSS 방지)
          var eventDomain = this.getEventDomain();
          var sUrl =
            eventDomain +
            '/event/getLeafItemIdsItemSiteListMsa.ssg?callBack=' +
            encodeURIComponent(callbackName) +
            '&nevntId=' +
            encodeURIComponent(nevntId) +
            '&domainSiteNo=' +
            encodeURIComponent(domainSiteNo) +
            '&itemIds=' +
            encodeURIComponent(this.getItemId()) +
            (config.siteNm ? '&aplSiteNo=' + encodeURIComponent(config.siteNm) : '');

          // JSONP 콜백 함수명 검증 (알파벳, 숫자, 언더스코어만 허용)
          if (!/^[a-zA-Z0-9_]+$/.test(callbackName)) {
            defer.reject(new Error('Invalid callback name'));
            return defer.promise();
          }

          window[callbackName] = function (data) {
            window[callbackName] = undefined;
            try {
              delete window[callbackName];
            } catch (e) {}
            var ele = document.getElementById(sId);
            if (ele && ele.parentNode) {
              ele.parentNode.removeChild(ele);
            }
            defer.resolve(data);
          };

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = sUrl;
          script.id = sId;

          if (script.addEventListener)
            // W3C DOM
            script.addEventListener('error', defer.reject);
          else if (script.attachEvent) {
            // IE DOM
            script.attachEvent('onerror', function () {
              defer.reject;
            });
          }

          document.getElementsByTagName('head')[0].appendChild(script);

          return defer.promise();
        }
      };

      function _setElementItem(oItem) {
        // 요소가 없으면 처리하지 않음
        if (!oItem.elem || oItem.elem.length === 0) {
          return;
        }

        // 브랜드명 설정
        if (oItem.brd !== null && oItem.brd !== undefined) {
          oItem.elem.find('.brd').text(oItem.brd);
        } else {
          oItem.elem.find('.brd').hide();
        }

        // 상품명 설정
        if (oItem.name) {
          oItem.elem.find('.tx').text(oItem.name);
        }

        var discountTxt = '';
        var priceText = '';
        var suffixText = '';

        if (oItem.discountTxt && oItem.discountTxt.trim() !== '') {
          discountTxt = String(oItem.discountTxt).trim();
          priceText = '<span class="discount_rate">' + escapeHtml(discountTxt) + '</span> ';
        }

        if (oItem.priceTxt && oItem.priceTxt.trim() !== '') {
          priceText += escapeHtml(oItem.priceTxt);
        } else {
          var basePrice = oItem.price || '가격 준비중';
          if (priceText) {
            priceText += escapeHtml(basePrice);
          } else {
            priceText = escapeHtml(basePrice);
          }
        }

        if (oItem.suffixTxt && oItem.suffixTxt.trim() !== '') {
          suffixText = oItem.suffixTxt;
        }

        if (!priceText || priceText.trim() === '') {
          priceText = escapeHtml(oItem.price || '가격 준비중');
        }

        oItem.elem.find('.price .won').remove();
        oItem.elem.find('.price em').html(priceText);

        if (suffixText) {
          oItem.elem
            .find('.price em')
            .after('<span class="sub_price">' + escapeHtml(suffixText) + '</span>');
        }

        oItem.elem.attr(
          'data-react-tarea',
          '이벤트상세HTML영역|' +
            escapeHtml(sDocumentTitle) +
            '|상품_클릭|' +
            escapeHtml(oItem.name) +
            '_' +
            escapeHtml(String(oItem.id))
        );

        if (oItem.brd === null) {
          oItem.elem.find('.brd').hide();
        }

        if (oItem.soldout) {
          oItem.elem.parent().addClass('cmbn_soldout');
          // soldoutText는 HTML을 포함할 수 있으므로 주의 (기본값에 <br> 포함)
          var soldoutHtml = config.soldoutText || '인기상품!<br>매진되었습니다';
          oItem.elem
            .after(
              '<span class="cmbn_soldout_ctrl"><span class="cmbn_soldout_tx">' +
                soldoutHtml +
                '</span></span>'
            )
            .find('.cmbn_thmb')
            .append('<span class="cmbn_soldout_dimmed"></span>');
          if (!oItem.name || !oItem.price) {
            oItem.elem.find('.tx, .price').hide();
          }
        }

        if (oItem.link) {
          oItem.elem.attr('href', oItem.link);
        }

        if (oItem.dispText && oItem.dispText.trim() !== '') {
          var dispTextElem = oItem.elem.siblings('.cmbn_bottom_label_wrap');
          var safeDispText =
            oItem.dispText && oItem.dispText !== 'null' && oItem.dispText.trim() !== ''
              ? escapeHtml(oItem.dispText)
              : '';
          var safeInfoText =
            oItem.infoText && oItem.infoText.trim() !== '' ? escapeHtml(oItem.infoText) : '';

          if (dispTextElem.length === 0) {
            if (oItem.infoText && oItem.infoText.trim() !== '') {
              oItem.elem.after(
                '<div class="cmbn_bottom_label_wrap"><div class="ssgitem_bottom_label ty_btn js_tagtip_box"><button type="button" class="ssgitem_bottom_btn sr_toggle js_tagtip_btn" data-position=".cmbn_bottom_label_wrap"><span class="sr_off"><span class="blind">배송비 정보 툴팁 열기</span></span><span class="sr_on"><span class="blind">배송비 정보 툴팁 닫기</span></span><span class="btn_text">' +
                  safeDispText +
                  '</span></button><div class="ssgcommon_tooltip ty_black js_tagtip_layer" role="tooltip" aria-label="배송비 정보"><button type="button" class="ssgcommon_tooltip_close js_close_btn"><span class="blind">툴팁 닫기</span></button><div>' +
                  safeInfoText +
                  '</div></div></div></div>'
              );
            } else {
              oItem.elem.after(
                '<div class="cmbn_bottom_label_wrap"><span class="ssgitem_bottom_label">' +
                  safeDispText +
                  '</span></div>'
              );
            }
          } else {
            if (oItem.infoText && oItem.infoText.trim() !== '') {
              dispTextElem.replaceWith(
                '<div class="cmbn_bottom_label_wrap"><div class="ssgitem_bottom_label ty_btn js_tagtip_box"><button type="button" class="ssgitem_bottom_btn sr_toggle js_tagtip_btn" data-position=".cmbn_bottom_label_wrap"><span class="sr_off"><span class="blind">배송비 정보 툴팁 열기</span></span><span class="sr_on"><span class="blind">배송비 정보 툴팁 닫기</span></span><span class="btn_text">' +
                  safeDispText +
                  '</span></button><div class="ssgcommon_tooltip ty_black js_tagtip_layer" role="tooltip" aria-label="배송비 정보"><button type="button" class="ssgcommon_tooltip_close js_close_btn"><span class="blind">툴팁 닫기</span></button><div>' +
                  safeInfoText +
                  '</div></div></div></div>'
              );
            } else {
              dispTextElem.replaceWith(
                '<div class="cmbn_bottom_label_wrap"><span class="ssgitem_bottom_label">' +
                  safeDispText +
                  '</span></div>'
              );
            }
          }
        }

        // if (oItem.couponSale) {
        //   oItem.elem
        //     .find('.cmbn_badge')
        //     .html(
        //       '<span class="cm_bdg"><span class="di_sale"><em class="blind">세일</em>' +
        //         oItem.couponSale +
        //         '<em class="per">%</em></span></span>'
        //     );
        // }
        if (oItem.ssgfestacoupon) {
          oItem.elem
            .find('.cmbn_badge')
            .html(
              '<div class="cm_bdg_v2 notranslate" aria-label="혜택"><i class="badge badge_smileday_shape" aria-label="페스타+페스타쿠폰"></i></div>'
            );
        }
        if (oItem.ssgsaleMD) {
          oItem.elem
            .find('.cmbn_badge')
            .html(
              '<div class="cm_bdg_v2 notranslate" aria-label="혜택"><i class="badge badge_ssg_choice_shape" aria-label="쓱세일+MD추천"></i></div>'
            );
        }
        if (oItem.ssgsalecoupon) {
          oItem.elem
            .find('.cmbn_badge')
            .html(
              '<div class="cm_bdg_v2 notranslate" aria-label="혜택"><i class="badge badge_ssgsale_coupon_shape" aria-label="쓱세일+쓱세일쿠폰"></i></div>'
            );
        }
        if (oItem.ssgsale) {
          oItem.elem
            .find('.cmbn_badge')
            .html(
              '<div class="cm_bdg_v2 notranslate" aria-label="혜택"><i class="badge badge_ssgsale_shape" aria-label="쓱세일"></i></div>'
            );
        }
        if (oItem.ssgday) {
          oItem.elem
            .find('.cmbn_badge')
            .html(
              '<div class="cm_bdg_v2 notranslate" aria-label="혜택"><i class="badge badge_ssgday_shape" aria-label="쓱데이+쿠폰"></i></div>'
            );
        }

        // A0: 에누리
        // B0: 할인율만 표기(디폴트)
        // C0: 쿠폰포함
        if (oItem.couponType === 'A0') {
          oItem.elem
            .find('.di_sale')
            .removeClass()
            .addClass('di_enuri')
            .find('em.blind')
            .text('에누리');
        } else if (oItem.couponType === 'C0') {
          oItem.elem
            .find('.di_sale')
            .removeClass()
            .addClass('di_coupon')
            .find('em.blind')
            .text('쿠폰포함');
        }
      }

      function init() {
        // 이미 초기화되었거나 초기화 중이면 실행하지 않음
        if (isInitialized || isInitializing) {
          return $.Deferred().resolve();
        }
        isInitializing = true;

        return oProductModel
          .getItemData(config.nevntId)
          .then(function (data) {
            var aDataResult = data.resultMsg,
              aPromises = [],
              oItem = {
                id: null,
                brd: null,
                name: null,
                price: null,
                couponType: null,
                couponSale: null,
                priceInfo: null,
                link: null,
                img: null,
                coming: null,
                ultemPrc: null,
                soldout: null,
                ssgsaleMD: null,
                ssgsalecoupon: null,
                ssgsale: null,
                ssgday: null,
                ssgfestacoupon: null,
                arrivalNotice: null,
                arrivalNoticeFunction: null,
                elem: null,
                infoText: null,
                dispText: null,
                discountTxt: null,
                priceTxt: null,
                suffixTxt: null
              };

            nResponseItem = aDataResult.length;

            if (data.resultCode === '00') {
              $.each(aDataResult, function (i, value) {
                oItem.id = value.itemId;
                oItem.brd = value.brandNm || null;
                oItem.siteNo = value.siteNo;
                oItem.name = value.itemNm || '상품명 준비중';
                oItem.price = value.price || '가격 준비중';
                oItem.couponSale = value.couponSale;
                oItem.couponType = value.offerTypeCd;
                oItem.priceInfo = value.priceInfo || null;
                oItem.discountTxt = value.discoutTxt || value.discountTxt || null;
                oItem.priceTxt = value.priceTxt || null;
                oItem.suffixTxt = value.suffixTxt || null;
                oItem.link = value.lnkdUrl;
                oItem.img = value.imgPath;
                oItem.coming = value.comingsoonYn === 'Y';
                oItem.ultemPrc = value.ultemPrc === 'N';
                if (config.dealCheck) {
                  oItem.deal = value.lnkdUrl && value.lnkdUrl.indexOf('dealItemView') !== -1;
                }
                oItem.soldout = value.soldOutYn === 'Y' || value.soldOutYn === '';
                oItem.ssgfestacoupon = value.festaCd === '20';
                oItem.ssgsaleMD = value.festaCd === '40';
                oItem.ssgsalecoupon = value.festaCd === '50' || value.festaCd === '70';
                oItem.ssgsale = value.festaCd === '60';
                oItem.ssgday = value.festaCd === '10';
                oItem.arrivalNotice = value.arrivalNotiBtnDispYn === 'Y';
                oItem.arrivalNoticeFunction = value.arrivalNotiBtnFnPc;
                oItem.elem = $('a[data-item-id="' + oItem.id + ':' + oItem.siteNo + '"]');
                if (oItem.elem.length === 0) {
                  oItem.elem = $('a[data-item-id*="' + oItem.id + '"]').filter(function () {
                    var itemIdAttr = $(this).attr('data-item-id');
                    return itemIdAttr && itemIdAttr.indexOf(oItem.id + ':') === 0;
                  });
                }
                oItem.infoText =
                  value.shppcstInfo && value.shppcstInfo[0]
                    ? value.shppcstInfo[0].infoTxt
                    : '배송 정보 준비중';
                oItem.dispText =
                  value.shppcstInfo && value.shppcstInfo[0] && value.shppcstInfo[0].dispTxt
                    ? value.shppcstInfo[0].dispTxt
                    : null;

                // 요소가 존재하는 경우에만 처리
                if (oItem.elem.length > 0) {
                  _setElementItem(oItem);
                  oItem.elem.data('setData', 'T');
                }
                aPromises.push(value);
              });
              return $.when.apply($, aPromises).promise();
            } else {
              return $.Deferred().resolve();
            }
          })
          .done(function () {
            if (nRequestItem !== nResponseItem) {
              welItems.each(function () {
                var welTarget = $(this);
                if (welTarget.data('setData') !== 'T') {
                  welTarget
                    .after(
                      '<span class="cmbn_soldout_ctrl"><span class="cmbn_soldout_tx">' +
                        config.soldoutText +
                        '</span></span>'
                    )
                    .find('.cmbn_thmb')
                    .append('<span class="cmbn_soldout_dimmed"></span>');
                  welTarget.find('.tx, .price').hide();
                }
              });
            }

            welList.find('.cmbn_soldout:not(.cmbn_replace)').each(function () {
              var welTarget = $(this);
              var welReplace = welTarget.siblings('.cmbn_replace:not(.cmbn_soldout)');
              if (welReplace.length) {
                welTarget.hide();
                welReplace.eq(0).removeClass('cmbn_replace');
              }
            });
          })
          .always(function () {
            // 초기화 완료 (성공/실패 모두)
            isInitialized = true;
            isInitializing = false;
          });
      }

      return {
        init: init
      };
    })();

    //상품정보 셋팅
    oEventItemInfoSet.init();

    // Slide, Tab, Layer 초기화
    if (config.useSlide || config.useTab || config.useLayer) {
      $(function () {
        if (config.useSlide) {
          // 프로모션 상품유닛 : Slide
          var initEventItemSlider = function () {
            var welSliderBanner = $('.cmbn_slide ul');
            welSliderBanner
              .filter(function () {
                return $(this).find('>li').length > 1;
              })
              .bxSlider({
                mode: 'fade',
                prevText: '<span class="blind">이전</span>',
                nextText: '<span class="blind">다음</span>'
              });
          };

          // 프로모션 SSG에 노출대비 bxslider 방어코드(SSG 리뉴얼 전까지만 사용)
          if ($().bxSlider) {
            initEventItemSlider();
          } else {
            $.getScript('https://sui.ssgcdn.com/ui/ssg/js/lib/jquery.bxslider.min.js').done(
              function () {
                initEventItemSlider();
              }
            );
          }
        }

        if (config.useTab) {
          // 프로모션 상품유닛 : Tab
          $('.cmbn_tab').tabs({
            sActiveClass: 'on',
            elTabBtn: '>.cmbn_tab_lst li',
            elTabPanel: '>.cmbn_tab_cont >.cmbn_tab_panel',
            elFilter: '.cmbn_tab_btn',
            fnChange: function (welPanel) {
              if ($(this).is('[role="tab"]')) {
                // 방어코딩 - role tab 속성이 있을때만 동작
                $(this)
                  .attr('aria-selected', 'true')
                  .parent()
                  .siblings()
                  .children()
                  .attr('aria-selected', 'false');
              }
            }
          });
        }

        if (config.useLayer) {
          // 레이어팝업
          var oSsgViewLayerPopup = new ssg.View.layerPopup({
            sTarget: '.btn_evtpop', // 레이어 팝업 보기 버튼
            sClose: '.btn_evtpop_close', // 레이어 팝업 닫기 버튼
            htDefault: {
              overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.7
              },
              onOverlayClick: function () {
                oSsgViewLayerPopup.closeLayer();
              } // overlay click 레이어 닫기
            }
          });
        }
      });
    }
  };
})(window);
